import {
  AnyIndustryEntityVersion,
  Cached,
  Collections,
  IndustryCommonDefaultProvider,
} from '@uploadcam/common';
import { CollectionReference, Firestore } from 'firebase/firestore';
import { getCollectionRef } from '../../@harmony/angular';
import { GetIndustriesInteractor } from './domain/interactors/get-industries.interactor';

export abstract class IndustryProvider {
  abstract provideGetIndustries(): GetIndustriesInteractor;
}

export class IndustryDefaultProvider implements IndustryProvider {
  private readonly industriesCollection: CollectionReference<AnyIndustryEntityVersion>;
  private readonly industryCommon = new IndustryCommonDefaultProvider();

  constructor(firestore: Firestore) {
    this.industriesCollection = getCollectionRef(firestore, Collections.Industries);
  }

  @Cached()
  public provideGetIndustries(): GetIndustriesInteractor {
    return new GetIndustriesInteractor(
      this.industriesCollection,
      this.industryCommon.provideIndustryEntityToIndustryMapper(),
    );
  }
}
